import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import accountReportsData from './accountReportsData.js';
import ReportOverview from '../../Reports/ReportOverview.js';

class AccountReports extends Component {
    render() {
        const { currentAccount } = this.props;

        return (
            <ReportOverview
                reportSectionData={ accountReportsData }
                currentAccount={ currentAccount }
            />
        );
    }
}

AccountReports.propTypes = {
    account: PropTypes.object
};

/**
 * @param state
 * @returns {{loading: *}}
 */
const mapStateToProps = (state) => ({
    currentAccount: state.accounts.currentAccount
});

export default connect(mapStateToProps)(AccountReports);